<style scoped>

</style>
<template>
    <div>
        <Table size="small" stripe border :columns="columns" :data="fin_teams" :loading="loading"></Table>
        <Modal
            transfer
            v-model="edit_config.modal"
            title="添加 / 修改"
            ok-text="保存"
            :loading="edit_config.loading"
            @on-ok="editOk">
            <Form ref="periodForm" :model="edit_month_period" :label-width="140">
                <Form-item label="项目发展阶段">
                    <Select transfer v-model="edit_month_period.period_id" @on-change="setDefaultValue">
                        <Option :value="period.id" v-for="period in periods" :key="period.id">{{period.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item label="费用池额度(全年)">
                    <Input v-model="edit_month_period.expense_pool" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="学习团建费人均标准">
                    <Input v-model="edit_month_period.expense_study_per_person" placeholder="请输入"></Input>
                </Form-item>
            </Form>
        </Modal>
    </div>
</template>
<script>
    export default {
        props: {
            periods: {
                type: Array,
                default: []
            },
            period_hash: {
                type: Object,
                default: {}
            }
        },
        data(){
            return {
                params: {
                    year: this.getCurYear()
                },
                loading: false,
                fin_teams: [],
                month_data: {},
                edit_month_period: {},
                edit_config: {
                    modal: false,
                    loading: true
                }
            }
        },
        computed: {
            columns(){
                let columns = [
                    {
                        title: '团队',
                        key: 'name',
                        align: 'center',
                        width: 140,
                        fixed: 'left',
                        renderHeader: (h, params)=>{
                            return h('div', [
                                h('DatePicker', {
                                    attrs: {
                                        style: 'width: 80px',
                                        placeholder: '选择月份',
                                    },
                                    props: {
                                        size: 'small',
                                        type: 'year',
                                        value: this.getCurYear(),
                                        options: {
                                            disabledDate(date){
                                                let now = new Date();
                                                let disabledDateStart = new Date('2017-12-31').getTime();
                                                let disabledDateEnd = new Date(`${now.getFullYear()}-12-31`).getTime();
                                                return date && ( date.valueOf() < disabledDateStart || date.valueOf() > disabledDateEnd);
                                            }
                                        }
                                    },
                                    on: {
                                        'on-change': (year)=>{
                                            this.params.year = year;
                                            this.getMonthData();
                                        }
                                    }
                                }),
                                h('span', ' '),
                                h('Button', {
                                    props: {
                                        size: 'small',
                                        type: 'primary'
                                    },
                                    on: {
                                        click: ()=>{
                                            this.getMonthData();
                                        }
                                    }
                                }, '确定')
                            ]);
                        }
                    }
                ];
                let months = [1,2,3,4,5,6,7,8,9,10,11,12];
                months.forEach((month)=>{
                    columns.push({
                        title: `${month} 月`,
                        align: 'center',
                        width: 200,
                        render: (h, params)=>{
                            let team = params.row;
                            let team_key = `t${team.id}`;
                            let team_hash = this.month_data[team_key];
                            let month_key = `m${month}`;
                            let month_hash = team_hash[month_key];
                            let period = this.period_hash[month_hash.period_id];
                            let month_expense_pool = math.eval(`${month_hash.expense_pool} / 12`).toFixed(2);
                            let ret = [
                                h('Button', {
                                    props: {
                                        size: 'small',
                                        type: 'text'
                                    },
                                    on: {
                                        click: ()=>{
                                            this.editMonthPeriod(month_hash);
                                        }
                                    }
                                }, period ? period.name : 'n/a')
                            ];
                            if(period){
                                ret = ret.concat([
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `当月费用池额度: ${Util.formatPrice(month_expense_pool)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `当月学习团建费: ${Util.formatPrice(month_hash.expense_study_total)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `(人均标准: ${Util.formatPrice(month_hash.expense_study_per_person)}, 人数: ${month_hash.staff_count})`),
                                ]);
                            }
                            return h('div', ret);
                        }
                    });
                });
                columns.push({
                    title: '全年',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    render: (h, params)=>{
                        let team = params.row;
                        let team_key = `t${team.id}`;
                        let team_hash = this.month_data[team_key];
                        let year_hash = team_hash.year;
                        if(year_hash){
                            let period = this.period_hash[year_hash.period_id];
                            let ret = [
                                h('div', {
                                    'class': {
                                        'text-bold': true
                                    }
                                }, period ? period.name : 'n/a')
                            ];
                            if(period){
                                ret = ret.concat([
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `全年费用池额度: ${Util.formatPrice(year_hash.expense_pool)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `去年费用池余额: ${Util.formatPrice(year_hash.last_year_expense_pool_balance)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `全年费用池合计: ${Util.formatPrice(year_hash.expense_pool_total)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `全年学习团建费: ${Util.formatPrice(year_hash.expense_study)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `去年学习团建费余额: ${Util.formatPrice(year_hash.last_year_expense_study_balance)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `全年学习团建费合计: ${Util.formatPrice(year_hash.expense_study_total)}`),
                                    h('div', {
                                        'class': {
                                            'color-grey': true
                                        }
                                    }, `(人均标准: ${Util.formatPrice(year_hash.expense_study_per_person)}, 人数: ${year_hash.staff_count})`),
                                ]);
                            }
                            return h('div', ret);
                        }else{
                            return h('span', '-');
                        }
                    }
                });
                return columns;
            }
        },
        created(){
            this.getMonthData();
        },
        mounted(){
            //
        },
        methods: {
            getMonthData(){
                this.loading = true;
                Util.ajax.get(Util.api.fin_team_period_month_data, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    console.log(res);
                    if(res.code === 1){
                        let data = res.data;
                        this.month_data = data.data_hash;
                        this.fin_teams = this.month_data.fin_teams;
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    console.log(e);
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            getCurYear(){
                let d = new Date();
                return d.getFullYear().toString();
            },
            editMonthPeriod(month_period){
                this.edit_month_period = Util.clone(month_period);
                this.setDefaultValue();
                this.edit_config.modal = true;
            },
            setDefaultValue(){
                let period = this.period_hash[this.edit_month_period.period_id];
                if(!period) return;
                this.edit_month_period.expense_pool = period.expense_pool;
                this.edit_month_period.expense_study_per_person = period.expense_study_per_person;
            },
            editOk(){
                Util.ajax.post(Util.api.update_fin_team_month_period, this.edit_month_period).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.edit_config.modal = false;
                        this.getMonthData();
                    }else{
                        this.resetEditLoading();
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.resetEditLoading();
                    console.log(e);
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            resetEditLoading(){
                this.edit_config.loading = false;
                setTimeout(()=>{
                    this.edit_config.loading = true;
                }, 500);
            }
        }
    }
</script>
